import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClockSnooze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 19a1 1 0 1 1 0-2h4a1 1 0 0 1 .707 1.707L20.414 21H22a1 1 0 1 1 0 2h-4a1 1 0 0 1-.707-1.707L19.586 19H18Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11c.805 0 1.59-.087 2.345-.25.228-.05.342-.075.423-.131a.44.44 0 0 0 .168-.197c.042-.09.05-.253.068-.58a3 3 0 0 1 .76-1.842A3 3 0 0 1 18 15h4c.163 0 .244 0 .287-.007a.457.457 0 0 0 .375-.298c.017-.04.029-.092.053-.196C22.9 13.696 23 12.86 23 12c0-6.075-4.925-11-11-11Zm0 4a1 1 0 0 1 1 1v5.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgClockSnooze.displayName = 'ClockSnooze';
export default SvgClockSnooze;
